module.exports = __webpack_public_path__ + "static/media/BSmokingDeaddictionClinic.9edf7d85.png";